import { createAsyncThunk } from "@reduxjs/toolkit";
import AnalysisStepAPI, 
{
    AdditionalAnalysisStepResponse,
    AnalysisStepParams,
    BorrowerVerificationStepResponse,
    CaseOverviewStepResponse,
    InterviewsStepResponse,
    PortfolioAnalysisStepResponse 
} from "../api/AnalysisStep";


export const fetchInterviewsStep = createAsyncThunk<
    InterviewsStepResponse,
    AnalysisStepParams,
    {rejectValue: void}
>(
    'analysisStep/fetchInterviewsStep',
    async (params, {rejectWithValue}) => {
        try {
            return await AnalysisStepAPI.getInterviewsStep(params);
        } catch(error) {
            console.error(error);
            return rejectWithValue();
        }
    }
)

export const fetchPortfolioAnalysis = createAsyncThunk<
    PortfolioAnalysisStepResponse,
    AnalysisStepParams,
    {rejectValue: void}
>(
    'analysisStep/fetchPortfolioAnalysis',
    async (params, {rejectWithValue}) => {
        try {
            return await AnalysisStepAPI.getPortfolioAnalysis(params);
        } catch(error) {
            console.error(error);
            return rejectWithValue();
        }
    }
)

export const fetchCaseOverview = createAsyncThunk<
  CaseOverviewStepResponse,
  AnalysisStepParams,
  { rejectValue: void }
>(
  "analysisStep/fetchCaseOverview",
  async (params, { rejectWithValue }) => {
    try {
      return await AnalysisStepAPI.getCaseOverview(params);
    } catch (error) {
      console.error(error);
      return rejectWithValue();
    }
  }
);


export const fetchBorrowerVerifications = createAsyncThunk<
    BorrowerVerificationStepResponse,
    AnalysisStepParams,
    {rejectValue: void}
>(
    'analysisStep/fetchBorrowerVerifications',
    async (params, {rejectWithValue}) => {
        try {
            return await AnalysisStepAPI.getBorrowerVerifications(params);
        } catch(error) {
            console.error(error);
            return rejectWithValue();
        }
    }
)

export const fetchAdditionalAnalysis = createAsyncThunk<
    AdditionalAnalysisStepResponse,
    AnalysisStepParams,
    {rejectValue: void}
>(
    'analysisStep/fetchAdditionalAnalysis',
    async (params, {rejectWithValue}) => {
        try {
            return await AnalysisStepAPI.getAdditionalAnalysis(params);
        } catch(error) {
            console.error(error);
            return rejectWithValue();
        }
    }
)